<template>
    <div class="draw-bg" v-if="isHaveReward && visiable">
        <div class="draw-wrap">
            <div
                class="draw"
                :class="{
                    'no-draw': drawState === DrawStatus.drawing,
                    'draw-result': isDrawResult
                }"
            >
                <div class="nowin-tip" v-if="drawState === DrawStatus.nowin">
                    <div class="title">很遗憾</div>
                    <div class="tip">与红包擦肩而过</div>
                </div>
                <div class="win-tip" v-if="drawState === DrawStatus.win">
                    <div class="title">恭喜您获得</div>
                    <div class="reward">{{ reward.gift }}</div>
                    <div class="tip">{{ reward.description }}</div>
                </div>
                <div class="tip2" v-if="isDrawResult">{{ rewardText || '' }}</div>
            </div>
            <div class="btns">
                <div class="btn-drawing" v-if="drawState === DrawStatus.drawing">
                    <div class="inner-drawing" @click="handleToReward">点我开奖</div>
                </div>
                <div v-else-if="drawState === DrawStatus.nowin" class="btn-nowin">
                    <div class="inner-nowin" @click="handleClose">关闭</div>
                </div>
                <div v-else-if="drawState === DrawStatus.win" class="btn-win-btns">
                    <div class="btn-win-close">
                        <div class="inner-close" @click="handleClose">关闭</div>
                    </div>
                    <div class="btn-win-share">
                        <div class="inner-share" @click="handleShare">分享给朋友</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
// import { nShare, appInfo } from '@eastmoney/utils';
import { nShare, appInfo } from '@eastmoney/mku';
import { RewardFlag, RewardType } from '@/libs/enum';
import { postReward } from '@/apis';

const DrawStatus = {
    drawing: '0',
    nowin: '-1',
    win: '1'
};
export default {
    name: 'questionnair-draw',
    data() {
        return {
            visiable: true,
            drawState: DrawStatus.drawing,
            DrawStatus,
            reward: {
                gift: 0,
                description: '',
                rewardType: ''
            }
        };
    },
    computed: {
        ...mapState(['questionnaireCode', 'rewardConfig']),
        isDrawResult() {
            return this.drawState === DrawStatus.win || this.drawState === DrawStatus.nowin;
        },
        isHaveReward() {
            return (
                this.$store.state.rewardConfig &&
                this.$store.state.rewardConfig.rewardFlag === RewardFlag.yes
            );
        },
        rewardText() {
            return this.rewardConfig && this.rewardConfig.rewardText;
        }
    },
    methods: {
        async handleToReward() {
            try {
                const { data } = await postReward(this.questionnaireCode, '');
                if (!data.success) {
                    if (data.code === '10001') {
                        this.$emit('on-need-login');
                    } else {
                        this.$toast(data.message);
                    }
                    return;
                }
                const { data: response } = data;
                if (response && response.fail) {
                    this.$toast(response.failHint);
                    return;
                }
                if (response && response.reward && response.reward.hasReward) {
                    // 抽中
                    this.drawState = DrawStatus.win;
                    this.reward = {
                        description: response.reward.description,
                        rewardType: response.reward.rewardType
                    };
                    if (response.reward.rewardType === RewardType.integral) {
                        this.reward.gift = `${response.reward.points}积分`;
                    } else if (response.reward.rewardType === RewardType.redpackage) {
                        this.reward.gift = `${response.reward.amount}元`;
                    } else if (response.reward.rewardType === RewardType.coupon) {
                        this.reward.gift = response.reward.title;
                    } else if (response.reward.rewardType === RewardType.notcoupon) {
                        this.reward.gift = response.reward.title;
                    } else if (response.reward.rewardType === RewardType.cash) {
                        this.reward.gift = `${response.reward.amount}元`;
                    }
                } else {
                    // 未抽中
                    this.drawState = DrawStatus.nowin;
                }
                console.log(response);
            } catch (error) {
                console.log(error);
            }
        },
        handleClose() {
            this.visiable = false;
        },
        handleShare() {
            const { shareInfo } = this.$store.state;
            appInfo.inApp(
                () => {
                    nShare({
                        ...shareInfo,
                        type: 'weixin,pengyouquan'
                    });
                },
                () => {
                    this.$wxShare.shareTo('wechat');
                }
            );
        }
    }
};
</script>
<style lang="scss" scoped>
@mixin drawBtn($startColor, $endColor) {
    width: 380px;
    height: 100px;
    text-align: center;
    border-radius: 16px;
    font-size: 32px;
    font-weight: 700;
    // background: linear-gradient(#ffac83,#d25516);
    background: linear-gradient($startColor, $endColor);
    border: 2px solid #000;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: transform 0.2s;
    user-select: none;
}
@mixin innerBtn($color) {
    width: 100%;
    height: 85px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 16px;
    background: $color;
}
.draw-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1002;
    .draw-wrap {
        position: absolute;
        left: 50%;
        top: 40%;
        transform: translate(-50%, -50%);
        .draw {
            width: 654px;
            height: 808px;
            .nowin-tip {
                display: flex;
                flex-direction: column;
                align-items: center;
                position: relative;
                top: 250px;
                .title {
                    font-size: 40px;
                    color: #333;
                    font-weight: 600;
                }
                .tip {
                    margin-top: 25px;
                    color: #666666;
                    font-size: 32px;
                }
            }
            .win-tip {
                display: flex;
                flex-direction: column;
                align-items: center;
                position: relative;
                top: 250px;
                .title {
                    font-size: 40px;
                    color: #333;
                    font-weight: 600;
                }
                .reward {
                    color: #fe5b30;
                    font-size: 65px;
                    font-weight: 700;
                    padding: 0 100px;
                    text-align: center;
                    font-size-adjust: 0.5;
                }
                .tip {
                    margin-top: 8px;
                    color: #999999;
                    font-size: 22px;
                }
            }
            .tip2 {
                position: absolute;
                bottom: 205px;
                color: #fce5ce;
                font-size: 22px;
                line-height: 44px;
                display: inline-block;
                width: 100%;
                text-align: center;
            }
        }
        .no-draw {
            background: url('../../assets/images/bg-before-draw.png') no-repeat center;
            background-size: 100%;
        }
        .draw-result {
            background: url('../../assets/images/bg-reward-result.png') no-repeat center;
            background-size: 100%;
        }
        .btns {
            display: flex;
            justify-content: center;
            margin-top: 60px;
            .btn-drawing {
                @include drawBtn(#ffac83, #d25516);
                .inner-drawing {
                    @include innerBtn(#ff6b20);
                }
            }
            .btn-nowin {
                @include drawBtn(#717171, #3c3c3c);
                .inner-nowin {
                    @include innerBtn(#3c3c3c);
                }
            }
            .btn-win-btns {
                display: flex;
                align-items: center;
                .btn-win-close {
                    @include drawBtn(#717171, #3c3c3c);
                    width: 224px;
                    .inner-close {
                        @include innerBtn(#3c3c3c);
                    }
                }
                .btn-win-share {
                    @include drawBtn(#fffc5c, #fecf21);
                    width: 290px;
                    margin-left: 34px;
                    .inner-share {
                        @include innerBtn(#fecf21);
                        color: #000000;
                    }
                }
            }
        }
    }
}
</style>
